import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import comparisonStyles from './Comparison.module.scss';
import {Tick2, Infinite} from '../../../assets';

export const ComparisonCard = ({list, data, active}) => {
  return (
    <div className={comparisonStyles.wrapper}>
      <div className={comparisonStyles.list}>
        {list.map((item) => (
          <div key={item.title} className={comparisonStyles.item}>
            <p className={comparisonStyles.title}>{item.title}</p>
            <div className={comparisonStyles.listFeatures}>
              {item.list.map((feature, i) => (
                <p className={comparisonStyles.feature} key={feature + i}>
                  {feature}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={comparisonStyles.comparisonWrapper}>
        {data.map((plan) => (
          <div
            className={clsx(comparisonStyles.comparisonItem, {
              [comparisonStyles.active]: active === plan.mark,
            })}
            key={plan.id}>
            <div className={clsx(styles.label, styles[plan.label])}>
              <div className={clsx(styles.labelInner, styles[plan.label])}>{plan.label}</div>
            </div>
            <div className={comparisonStyles.top}>
              <p className={comparisonStyles.price}>${plan.price}</p>
              <p className={comparisonStyles.condition}>{plan.condition}</p>
            </div>
            <div className={comparisonStyles.list}>
              {list.map((item) => (
                <div key={item.title} className={comparisonStyles.item}>
                  <p className={comparisonStyles.title}>{item.title}</p>
                  <div className={comparisonStyles.listFeatures}>
                    {item.list.map((feature, i) => {
                      return (
                        <div
                          className={clsx(comparisonStyles.feature, {
                            [comparisonStyles.active]: active === plan.mark,
                          })}
                          key={feature + i}>
                          <div className={comparisonStyles.infinite}>
                            {plan.features[item.title][feature] === 'infinity' && <Infinite />}
                          </div>
                          <div className={comparisonStyles.tick}>
                            {plan.features[item.title][feature] === 'check' && <Tick2 />}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
